import React from 'react';
import styles from './css/ThankYouPage.module.css';

const ThankYouPage = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h1 className={styles.title}>Спасибо за оплату!</h1>
        <p className={styles.subtitle}>
          Если платёж не прошёл — пожалуйста, напишите <a href="https://vk.com/ez.bej1ukuu" target="_blank" rel="noopener noreferrer" style={{ color: '#54a0ff', textDecoration: 'underline' }}>администратору</a>.
        </p>
        <div className={styles.buttonGroup}>
          <a href="https://vk.com/newchatgpt" className={styles.button}>
            Вернуться к диалогу
          </a>
          <a href="/" className={styles.button}>
            На главную
          </a>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
